import Vue from 'vue'
import Router from 'vue-router'
import env from "@env";
import { Gtag, GtagAnalyticsConfig } from "gtag";

Vue.use(Router)

const router = new Router({
    scrollBehavior: (to, from, savedPosition) => {

        return { x: 0, y: 0 }
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Top.vue')
        },
        {
            path: '/debug',
            name: 'debug',
            component: () => import('./views/debug/Debug.vue')
        },
        {
            path: '/terms',
            name: 'terms',
            component: () => import('./views/Terms.vue')
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/Privacy.vue')
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import('./views/FaQ.vue')
        },
        {
            path: '/howto',
            name: 'howto',
            component: () => import('./views/HowTo.vue')
        },
        {
            path: '/faq/:id',
            name: 'faq-about',
            component: () => import('./views/FaQAbout.vue')
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('./views/News.vue')
        },
        {
            path: '/news/:id',
            name: 'news-about',
            component: () => import('./views/NewsAbout.vue')
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: () => import('./views/Transactions.vue')
        },
        {
            path: '/artist/:slug',
            name: 'artist',
            component: () => import('./views/artist/Artist.vue')
        },
        {
            path: '/artist/:slug/plan/:planId/checkout',
            name: 'artist-checkout',
            component: () => import('./views/artist/Checkout.vue')
        },
        {
            path: '/artist/:slug/plan/:planId/complete',
            name: 'artist-complete',
            component: () => import('./views/artist/Complete.vue')
        },
        {
            path: '/lineup',
            component: () => import('./views/artist/Category.vue')
        },
        {
            path: '/lineup/:slug',
            name: 'lineup',
            component: () => import('./views/artist/Artist.vue')
        },
        {
            path: '/lineup/:slug/:no',
            name: 'lineup',
            component: () => import('./views/artist/Artist.vue')
        },
        {
            path: '/lineup/:slug/plan/:planId/checkout',
            name: 'lineup-checkout',
            component: () => import('./views/artist/Checkout.vue')
        },
        {
            path: '/lineup/:slug/plan/:planId/complete',
            name: 'artist-complete',
            component: () => import('./views/artist/Complete.vue')
        },
        {
            path: '/category/:category',
            name: 'category',
            component: () => import('./views/artist/Category.vue')
        },
        {
            path: '/mypage/signup',
            name: 'signup',
            component: () => import('./views/mypage/SignUp.vue'),
            props: { type: 'signup', },
        },
        {
            path: '/mypage/reminder',
            name: 'passRemind',
            component: () => import('./views/mypage/SignUp.vue'),
            props: { type: 'reminder', },
        },
        {
            path: '/mypage/login',
            name: 'login',
            component: () => import('./views/mypage/Login.vue'),
        },
        {
            path: '/mypage/profile',
            name: 'mypage-profile',
            component: () => import('./views/mypage/Profile.vue')
        },
        {
            path: '/mypage/profile/email',
            name: 'mypage-profile-email',
            component: () => import('./views/mypage/Email.vue')
        },
        {
            path: '/mypage/profile/password',
            name: 'mypage-profile-password',
            component: () => import('./views/mypage/Password.vue')
        },
        {
            path: '/mypage/profile/adress',
            name: 'mypage-profile-adress',
            component: () => import('./views/mypage/Adress.vue')
        },
        {
            path: '/mypage/profile/payment',
            name: 'mypage-profile-payment',
            component: () => import('./views/mypage/PaymentMethod.vue')
        },
        {
            path: '/mypage/plan',
            name: 'mypage-plan',
            component: () => import('./views/mypage/Plan.vue')
        },
        {
            path: '/mypage/plan/:slug/:planId/delete',
            name: 'mypage-planDelete',
            component: () => import('./views/mypage/PlanDelete.vue')
        },
        {
            path: '/mypage/orderHistroy',
            name: 'mypage-orderHistroy-list',
            component: () => import('./views/mypage/OrderHistroy.vue')
        },
        {
            path: '/mypage/orderHistroy/:id/receipt',
            name: 'mypage-orderHistroy-receipt',
            component: () => import('./views/mypage/OrderHistroyReceipt.vue')
        }
    ]
});

router.afterEach((to, from) => {

    // GA
    let param: GtagAnalyticsConfig = {};
    param.transport_type = "beacon";
    param.page_location = window.location.href;
    param.page_path = to.path;
    Gtag.init(env.GOOGLE_ANALYTICS, param);
})

export default router;